<section class="article">
  <article>
    <h2>Fehler: Beim Zugriff auf den Server ist ein Fehler aufgetreten</h2>
    <p>
      Bitte versuchen Sie es später noch einmal.
    </p>
    <a class="call" [routerLink]="['/home']">Zur Startseite</a>
  </article>
</section>
